// emailservice.js

import emailjs from '@emailjs/browser';

class EmailJSService {
  constructor() {
    this.serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID;
    this.templateIdAdmin = process.env.REACT_APP_EMAILJS_TEMPLATE_ID_ADMIN;
    this.templateIdClient = process.env.REACT_APP_EMAILJS_TEMPLATE_ID_CUSTOMER;
    this.publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;
    this.adminEmail = process.env.REACT_APP_ADMIN_EMAIL;

    emailjs.init(this.publicKey);
  }

  // ✅ Email for the admin
  async sendReservationEmail(formData) {
    try {
      const emailData = {
        to_email: this.adminEmail,
        from_name: 'Riviera Signature VTC',
        from_email: 'rivierasignaturevtc@gmail.com',
        reply_to: formData.email || 'noreply@example.com',
        reservation_id: formData.reservationId || 'N/A',
        customer_name: formData.name || 'N/A',
        customer_phone: formData.phone || 'N/A',
        customer_email: formData.email || 'N/A',
        service_type: formData.service || 'N/A',
        pickup_date: formData.pickupDate || 'N/A',
        pickup_time: formData.pickupTime || 'N/A',
        pickup_address: formData.pickupAddress || 'N/A',
        destination: formData.destination || 'N/A',
        passengers: formData.passengers || 1,
        distance_km: formData.distanceKm || 0,
        estimated_price: formData.estimatedPrice || '0.00',
        notes: formData.notes || 'Aucune note spécifique',
        subject: `🚗 Nouvelle réservation Riviera Signature VTC - ${formData.name || 'Client'}`
      };

      console.log('📧 Envoi email admin avec données:', emailData);

      const result = await emailjs.send(
        this.serviceId,
        this.templateIdAdmin,
        emailData
      );

      console.log('✅ Email admin envoyé via EmailJS', result);
      return result;
    } catch (error) {
      console.error('❌ Erreur EmailJS admin:', error);
      throw error;
    }
  }

  // ✅ Email for the client
  async sendCustomerConfirmationEmail(formData) {
    try {
      if (!formData.email) return;

      const emailData = {
        to_email: formData.email,
        from_name: 'Riviera Signature VTC',
        from_email: 'rivierasignaturevtc@gmail.com',
        reply_to: this.adminEmail,
        reservation_id: formData.reservationId || 'N/A',
        customer_name: formData.name || 'N/A',
        service_type: formData.service || 'N/A',
        pickup_date: formData.pickupDate || 'N/A',
        pickup_time: formData.pickupTime || 'N/A',
        pickup_address: formData.pickupAddress || 'N/A',
        destination: formData.destination || 'N/A',
        passengers: formData.passengers || 1,
        distance_km: formData.distanceKm || 0,
        estimated_price: formData.estimatedPrice || '0.00',
        notes: formData.notes || 'Aucune note spécifique',
        subject: `✅ Confirmation réservation #${formData.reservationId || 'N/A'}`
      };

      console.log('📧 Envoi email client avec données:', emailData);

      const result = await emailjs.send(
        this.serviceId,
        this.templateIdClient,
        emailData
      );

      console.log('✅ Email client envoyé via EmailJS', result);
      return result;
    } catch (error) {
      console.error('❌ Erreur EmailJS client:', error);
      throw error;
    }
  }
}

export default new EmailJSService();